import Num2persian from 'num2persian'
import React, { useEffect, useState } from 'react'
import "./PreFaktorPrintBody.scss"
import NoImage from "assets/images/noImage.png"
import { separateEachThreeNumber } from 'functions/globalFunction'
const PreFaktorPrintBody = ({ prefaktorInfo }) => {
    const serverDomain = process.env.REACT_APP_Server_Domain

    console.log(prefaktorInfo)
    // const commodities = prefaktorInfo.items

    const [commodities, setCommodities] = useState(prefaktorInfo);
    const [faktorEachRowTotalPrice, setFaktorEachRowTotalPrice] = useState([]);
    const [TotalFaktorPriceInNumber, setTotalFaktorPriceInNumber] = useState([]);

    console.log(commodities)


    const a = () => {

        const temp = []
        commodities.map((commodity, index) => {
            const salesPrice = commodity.sales_price
            const count = commodity.count
            if (salesPrice > 0 && count > 0) {
                const total = parseInt(salesPrice) * parseInt(count)
                temp.push({ totalPrice: total })
                // setCommodities(temp)
                // return total
            } else {
                // temp[index].totalPrice = null
                temp.push({ totalPrice: null })
                // return null
            }
        
        })
        setFaktorEachRowTotalPrice(temp)
        console.log(temp)

        const inputFieldsHasTotalPrice = temp.filter(
            (item) => item.totalPrice > 0
        );
        const sum = inputFieldsHasTotalPrice.reduce(
            (acc, object) => (object.totalPrice ? acc + object.totalPrice : null),
            0
        );
        setTotalFaktorPriceInNumber(sum);
    }

    useEffect(() => {
        a()
    }, [prefaktorInfo]);


    // const calcEachTotalPrice = (salesPrice, count, index) => {

    //     if (salesPrice > 0 && count > 0) {
    //         const total = parseInt(salesPrice) * parseInt(count)
    //         const temp = commodities
    //         temp[index].totalPrice = total
    //         setCommodities(temp)
    //         return total
    //     } else {
    //         // const temp = commodities
    //         // temp[index].totalPrice = null
    //         // setCommodities(temp)
    //         return null
    //     }
    // }






    const sumOfFactorPrice = () => {
        // // filter fields that has totalPrice key
        const inputFieldsHasTotalPrice = commodities.filter(
            (item) => item.totalPrice > 0
        );
        const sum = inputFieldsHasTotalPrice.reduce(
            (acc, object) => (object.totalPrice ? acc + object.totalPrice : null),
            0
        );
        setTotalFaktorPriceInNumber(sum);
    };
    // end calculate sum price of faktor

    // useEffect(() => {
    //     sumOfFactorPrice();
    //   }, [commodities]);


    return (
        <div className='prefaktor-print-body-container'>
            <table className='prefaktor-print-body-table'>
                <thead>
                    <tr>
                        <th>
                            ردیف
                        </th>
                        <th>
                            تصویر کالا
                        </th>
                        <th>
                            نام کالا
                        </th>
                        <th>
                            تعداد
                        </th>
                        <th>
                            مبلغ واحد
                        </th>
                        <th>
                            مبلغ کل
                        </th>
                        <th>
                            توضیحات کالا
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {commodities.map((commodity, index) => {
                        //  i convert to stringify in select option to get
                        // all of object as a value, so must parse the object
                        // const commodity = JSON.parse(commodityInstringify.commodityInfo)

                        return (
                            <tr>
                                <td>
                                    {index + 1}
                                </td>
                                <td>
                                    <img
                                        className='prefaktor-print-body-table-image'
                                        src={commodity.image ?
                                            // `${serverDomain}/storage/${commodity.image}`
                                            `${serverDomain}/storage/app/public/${commodity.image}`
                                            : NoImage} alt={commodity.name} />
                                </td>
                                <td>
                                    {commodity.name}
                                </td>
                                <td>
                                    {commodity.count}
                                </td>
                                <td>
                                    {separateEachThreeNumber(commodity.sales_price) || "- - -"}
                                </td>
                                <td>
                                    {faktorEachRowTotalPrice[index] ?
                                        separateEachThreeNumber(faktorEachRowTotalPrice[index].totalPrice) : "- - -"}
                                    {/* {calcEachTotalPrice(commodity.sales_price, commodityInstringify.count, index) || 0} */}
                                </td>
                                <td>
                                    {commodity.description}
                                </td>
                            </tr>
                        )
                    })
                    }
                    <tr className='prefaktor-print-body-last-row'>
                        <td colSpan={5} className="text-end font-size-12 p-1" >
                            مبلغ پیش فاکتور:

                        </td>
                        <td colSpan={1}>

                        </td>
                        <td colSpan={1}>

                        </td>
                    </tr>
                    <tr className='font-size-12'>
                        <td colSpan={5} className="text-end p-2">
                            {`${Num2persian(TotalFaktorPriceInNumber)} ریال`}
                        </td>
                        <td colSpan={1} className="prefaktor-print-body-last-row-totla-price">
                            {
                                separateEachThreeNumber(TotalFaktorPriceInNumber)
                            }
                        </td>
                        <td colSpan={1} className="text-end p-2">
                            ریال
                        </td>

                    </tr>
                </tbody>
            </table>
        </div >
    )
}

export default PreFaktorPrintBody